<template>
  <div>
    <value-or-variable v-model='value' type='string' :variables='[]' toggle-position='col' @change='onChange'>
      <template #default=''>
        <toggle-switch v-model='value' />
      </template>
    </value-or-variable>
  </div>
</template>

<script>
import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import ValueOrVariable from '@ui/molecules/ValueOrVariable.vue';
import { abstractField } from "vue-form-generator";
export default {
  mixins: [ abstractField ],
  data() {
    return {
    }
  },
  components:{
    ValueOrVariable,
    ToggleSwitch
  },
  methods: {
    onChange({nv,ov}) {
      this.$emit("change", {nv,ov});
    }
  },
  computed:{
  },
}
</script>

